// extracted by mini-css-extract-plugin
module.exports = {"gameCenterPage":"style__gameCenterPage__yLflb","gameGrid":"style__gameGrid__R1WOn"};